/* eslint-disable import/extensions */
import { put, takeLatest, call } from 'redux-saga/effects';
import { LOAD_USER_IS_LOGGEDIN } from '../constants';
import { errorUserIsLoggedIn, pendingUserIsLoggedIn } from '../actions';

export function* setUserModel({ payload }) {
  yield put(pendingUserIsLoggedIn());
  try {
    localStorage.removeItem('logOutForce');
    yield call(payload.login, payload.response);
    yield put(successUserIsLoggedIn(payload));
  } catch (error) {
    yield put(errorUserIsLoggedIn(error));
  }
}

export default function* userSaga() {
  yield takeLatest(LOAD_USER_IS_LOGGEDIN.ACTION, setUserModel);
}
